/**
 *
 * @param labels
 * @returns {string}
 */
export const getCompositeLabel = (labels) => {
  let compositeLabel = '';
  let counter = 1;
  if (labels.length === 0) {
    compositeLabel = '_______';
  } else {
    labels.forEach((label) => {
      if (counter === labels.length && labels.length > 1) {
        compositeLabel += ', and ' + label;
      } else {
        if (counter === 1) {
          compositeLabel += label;
        } else {
          compositeLabel += ', ' + label;
        }
      }
      counter++;
    });
  }
  return compositeLabel;
};

/**
 *
 * @param jobSeekerData
 * @param stateProps
 * @param option
 * @returns {string}
 */
export const getButtonLabel = (jobSeekerData, stateProps, option) => {
  const index = 0;
  let buttonLabel = '';
  const buttonValue = stateProps.bulletData.bulletValue;
  if (typeof option.origMatches !== 'undefined' && option.origMatches.length > 0) {
    const rawkey = option.origMatches[index][0];
    let key = rawkey;
    if (rawkey.substring(0, 2) == '{{') {
      key = rawkey.substring(2, rawkey.length - 2);
    }
    if (option.type === 'recommended') {
      if (jobSeekerData[stateProps.sectionData.sectionIndex][key]) {
        buttonLabel = jobSeekerData[stateProps.sectionData.sectionIndex][key];
      } else {
        buttonLabel = '_______';
      }
/*
      if (stateProps.bulletData.bulletGroup === 'fillable') {

        option.type = 'fillable';
        option.prevType = 'rec';
      }*/
    } else {
      if (option.key === buttonValue.key) {
        //new entry
        if (buttonValue.key) {
          buttonLabel = buttonValue.value;
        } else {
          //Is  this unreachable...
          buttonLabel = '______';
        }
        option.buttonLabels[0] = typeof buttonValue.value === 'undefined' ? 'add text' : [buttonValue.value];
      } else {
        //old entry
        if (option.buttonLabels[0]) {
          if (option.buttonLabels[0][0] !== undefined && option.buttonLabels[0][0] !== option.qid) {
            const origMatch = option.origMatches[0][0].substring(2, option.origMatches[0][0].length - 2);
            if (Array.isArray(option.buttonLabels[0]) && (option.prevType === 'rec' || key !== origMatch )) {
              buttonLabel = option.buttonLabels[0][0];
            } else {
              if(option.type === 'freeform') {
                buttonLabel = 'Enter your own bullet here';
              } else {
                buttonLabel = '______';
              }
            }
          } else {
            buttonLabel = option.buttonLabels[0];
          }
        } else {
          buttonLabel = option.buttonLabels[0];
        }
      }
    }
  }
  return buttonLabel;
};